import { Eye, EyeOff } from "@assets"
import type * as React from "react"
import { useState } from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  const [showPassword, setShowPassword] = useState(false)
  const isPassword = type === "password"
  const actualType = isPassword && showPassword ? "text" : type

  const inputElement = (
    <input
      type={actualType}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input bg-card flex h-10 w-full min-w-0 rounded-[9px] border px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "placeholder:text-muted-foreground placeholder:text-[15px] placeholder:leading-[23px] placeholder:font-[400] placeholder:tracking-[0px] placeholder:opacity-[0.51]",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        isPassword && "pr-10",
        className,
      )}
      {...props}
    />
  )

  if (!isPassword) return inputElement

  return (
    <div className="relative flex items-center">
      {inputElement}
      <button
        type="button"
        onClick={() => setShowPassword((prev) => !prev)}
        className="focus-visible:ring-ring absolute inset-y-0 right-3 flex items-center focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
        aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
      >
        {showPassword ? (
          <Eye className="fill-sidebar-ring size-6" />
        ) : (
          <EyeOff className="fill-muted-foreground size-6" />
        )}
      </button>
    </div>
  )
}

export { Input }
